import React, { useImperativeHandle, useState } from 'react';
import CampaignCategoryDialog from './CampaignCategoryDialog';
import CampaignProductSearchDialog from './CampaignProductSearchDialog';
import { getItemKey } from '../CampaignEdit.config';

// 視窗代號：分類選擇
const CAMPAIGN_CATEGORY = 'CAMPAIGN_CATEGORY';
// 視窗代號：單品搜尋
const CAMPAIGN_PRODUCT_SEARCH = 'CAMPAIGN_PRODUCT_SEARCH';

/**
 * 抵用券視窗統一管理，由 ref 開啟
 * - 名單由 props 傳入而非開窗時帶入，視窗開啟期間加入或移除才能即時反映已加入狀態
 * - 關閉時卸載視窗，下次開啟不保留搜尋文字與分類展開狀態
 */
const CampaignDialogBox = React.forwardRef(({ includeItems, excludeItems, categoryTrees, onAdd, onRemove }, ref) => {
    // 目前開啟的視窗代號
    const [openDialog, setOpenDialog] = useState('');
    // 開窗時帶入的名單欄位名稱與視窗標題
    const [sourceData, setSourceData] = useState({});

    useImperativeHandle(
        ref,
        () => ({
            openCategoryDialog: (targetData = {}) => {
                setSourceData(targetData);
                setOpenDialog(CAMPAIGN_CATEGORY);
            },
            openProductSearchDialog: (targetData = {}) => {
                setSourceData(targetData);
                setOpenDialog(CAMPAIGN_PRODUCT_SEARCH);
            },
        }),
        [],
    );

    // 關閉視窗並清除帶入資料
    const handleCloseDialog = () => {
        setOpenDialog('');
        setSourceData({});
    };

    const { listKey, title } = sourceData;
    // 目前操作名單已加入項目的唯一鍵，視窗用來判斷已加入狀態
    const selectedKeys = (listKey === 'includeItems' ? includeItems : excludeItems).map(getItemKey);
    // 加入項目到目前操作的名單
    const handleAdd = item => onAdd(listKey, item);
    // 從目前操作的名單移除項目
    const handleRemove = item => onRemove(listKey, item);

    return (
        <React.Fragment>
            {openDialog === CAMPAIGN_CATEGORY && (
                <CampaignCategoryDialog open title={title} categoryTrees={categoryTrees} selectedKeys={selectedKeys} onAdd={handleAdd} onRemove={handleRemove} onClose={handleCloseDialog} />
            )}
            {openDialog === CAMPAIGN_PRODUCT_SEARCH && <CampaignProductSearchDialog open title={title} selectedKeys={selectedKeys} onAdd={handleAdd} onRemove={handleRemove} onClose={handleCloseDialog} />}
        </React.Fragment>
    );
});

export default CampaignDialogBox;
